import { useQuery } from "@tanstack/react-query";
import { API } from "../utils/Api";

export function useDocumentsListQuery(clientId:string|undefined, patientId:string|undefined) {
    return useQuery({
        queryKey: ['documents.list', clientId, patientId],
        queryFn: async () => (await API.getDocumentsList(clientId || "", patientId || "")),
        select: (data) => data,
        enabled:(!!clientId && !!patientId),
        staleTime:240_000
    });
}